import { render, staticRenderFns } from "./3-onboarding.vue?vue&type=template&id=4eec6832&scoped=true&"
import script from "./3-onboarding.vue?vue&type=script&lang=js&"
export * from "./3-onboarding.vue?vue&type=script&lang=js&"
import style0 from "./3-onboarding.vue?vue&type=style&index=0&id=4eec6832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec6832",
  null
  
)

export default component.exports